import React from 'react';
import SMA8Beacon from 'components/others/SMA8Beacon';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import SMReservationHelper from 'components/helpers/SMReservationHelper';
import SMConst from 'lib/SMConst';
import SMGuideAppDownload from './SMGuideAppDownload';

class SMReservationRequestSentView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      mailUrl: "",
      fbUrl: "",
      lineUrl: "",
    };
  }

  componentDidMount() {
    const reservation = this.props.reservation;
    const room = reservation.room;
    SMTrackHelper.criteoTransaction(this.props.currentUser.email, "2-" + reservation.uid, room.uid, SMFormatHelper.price(reservation.billing.total_amount), 1);
    this.setState({
      mailUrl: SMAppHelper.shareRoomMailUrl(room),
      fbUrl: SMAppHelper.shareRoomFacebookMessageUrl(room),
      lineUrl: SMAppHelper.shareRoomLineUrl(room),
    });
  }
  
  a8BeaconTag(reservation) {
    const amount = Number(reservation.billing.total_amount);
    const params = {order_id: reservation.id, unit_amount: amount, number: 1, total_amount: amount, item_code: reservation.room.id};
    return <SMA8Beacon delegate={this} params={params} />;
  }
  
  render() {
    const reservation = this.props.reservation;
    const room = reservation.room;
    const bankPaymentName = reservation.id + " " + SMFormatHelper.bankPaymentName(this.props.currentUser.contact);
    const remainingDays = reservation.remining_days_for_approval;

    return(
      <div className="site-main">
        <div className="page__even page__padding">
          <div className="container">
            {(()=>{
              if (SMReservationHelper.isCompletedReservation(reservation)) {
                return (
                  <div className="page-xs12-head">
                    <h1 className="page-title">予約が完了しました</h1>
                    <p className="page-description">以下の内容で予約が完了しました。</p>
                  </div>
                );
              } else if (reservation.status == SMConst.ReservationStatus.Paying) {
                return (
                  <div className="page-xs12-head">
                    <h1 className="page-title">お支払い方法(銀行振込)</h1>
                    <p className="page-description bank-description">下記の銀行口座まで代金をお振り込み下さい。内容はメールでもお送りしています。</p>
                    <div className="bank-account">
                      <p>ジャパンネット銀行 すずめ支店 普通 6011121</p>
                      <p>株式会社スペースマーケット</p>
                      <p className="bank-account__info">振込人名には予約番号と、連絡先に登録しているお名前「{bankPaymentName}」をご入力ください。</p>
                    </div>
                  </div>
                );
              } else {
                return (
                  <div className="page-xs12-head">
                    <h1 className="page-title">予約リクエストを送信しました</h1>
                    <p className="page-description">ホストからの承認をお待ちください。<br />{remainingDays}日以内に承認もしくは否認されない場合は期限切れとなります。</p>
                    {this.props.requestHost == "spacemarket.com" ? this.a8BeaconTag(reservation) : null}
                  </div>
                );
              }
            })()}
            <div className="row">
              <div className="col-sm-12 col-md-5">
                <div className="site-sidebar">
                  <a href={Routes.space_room_path(room.space.username, room.uid)}>
                    <div className="side-space__units">
                      <img src={SMFormatHelper.roomImageURL(room, {width: 630, height: 420})} alt="" />
                      <h2 className="side-space__units-title">{SMFormatHelper.roomName(room)}</h2>
                    </div>
                  </a>
                </div>
                <div className="complete-social mb30">
                  <p className="ta-c complete-social__title">このスペースをシェア</p>
                  <ul className="row complete-social__list">
                    {/* <li className="col-xs-4">
                      <a href="#" className="social-link__mail"><i class="fa fa-twitter"></i></a>
                    </li> */}
                    <li className="col-xs-4">
                      <a href={this.state.mailUrl} className="social-link__mail"><i className="fa fa-envelope"></i></a>
                    </li>
                    <li className="col-xs-4">
                      <a href={this.state.fbUrl} className="social-link__facebook"><i className="fa fa-facebook-square"></i></a>
                    </li>
                    <li className="col-xs-4">
                      <a href={this.state.lineUrl} target="_blank" className="social-link__line"><i className="icon-spm-line"></i></a>
                    </li>
                  </ul>
                </div>
                {(()=>{
                  if (SMReservationHelper.isCompletedReservation(reservation)) {
                    return (
                      <div className="complete-social">
                        <p className="ta-c complete-social__title">この予約の利用日程表を確認できます</p>
                        <div className="ta-c">
                          <a href={Routes.itinerary_path(reservation.uid)} className="button-blue pt13 pb13 w200">利用日程表</a>
                        </div>
                      </div>
                    );
                  }
                })()}
              </div>
              <div className="col-sm-12 col-md-7">
                {SMRenderHelper.renderBillingTable(reservation, {className: "popup-form__dl complete-detail"})}
                <div className="complete-detail__btn">
                  <a href={Routes.dashboard_reservation_path(reservation.uid)} className="button-blue pt15 pb15 w200">この予約の詳細へ</a>
                </div>
              </div>
            </div>
            <SMGuideAppDownload />
          </div>
        </div>
      </div>
    );
  }

}

export default SMReservationRequestSentView;



// WEBPACK FOOTER //
// ./app/javascript/components/reservations/SMReservationRequestSentView.jsx